import { Outlet } from "react-router-dom";
import HotelList from "./HotelList/HotelList";
import HotelForm from "./HotelForm/HotelForm";
import HotelMedia from "./HotelMedia/HotelMedia";
import RoomForm from "./Rooms/RoomForm";
import RoomList from "./RoomList";

export const adminHotelsRoutes = [
  {
    path: "hotels",
    element: Outlet,
    children: [
      {
        path: "",
        element: HotelList,
      },
      {
        path: "add",
        element: HotelForm,
      },
      {
        path: "edit/:id",
        element: HotelForm,
      },
      {
        path: "media/:id",
        element: HotelMedia,
      },
      {
        path: ":hotelID/rooms",
        element: RoomList,
      },
      {
        path: ":hotelID/rooms/:id",
        element: RoomForm,
      }
    ],
  },
];
